import { render } from "./ProjectsFilter.vue?vue&type=template&id=c66a8428"
import script from "./ProjectsFilter.vue?vue&type=script&lang=js"
export * from "./ProjectsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__